export function viewInboxSLATourPopover() {
  return {
    key: 'view-inbox-sla-tour-popover',
    properties: {
      action: 'viewed Inbox SLA tour'
    }
  };
}
export function dismissInboxSLATourPopover() {
  return {
    key: 'dismiss-inbox-sla-tour-popover',
    properties: {
      action: 'clicked to dismiss Inbox SLA tour'
    }
  };
}